// import React, { useState, useEffect } from 'react';
// import { Car, AlertCircle, CheckCircle, Loader2, Info } from 'lucide-react';
// import axios from 'axios';

// const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://app.krush.in/api';

// function AddDeviceModal({
//   isIMEIValid,
//   handleIMEIValidation,
//   handleCancelValidation,
//   handleAddDevice,
//   newDeviceModel,
//   setNewDeviceModel,
//   newDeviceName,
//   setNewDeviceName,
//   newDeviceIMEI,
//   setNewDeviceIMEI,
//   newDeviceMSDN,
//   setNewDeviceMSDN,
//   newDeviceIMSI,
//   setNewDeviceIMSI,
//   newDeviceType,
//   setNewDeviceType,
//   setShowAddDeviceModal,
//   newDeviceVehicleType,
//   setNewDeviceVehicleType,
// }) {
//   const [credits, setCredits] = useState(null);
//   const [loadingCredits, setLoadingCredits] = useState(true);
//   const [userRole, setUserRole] = useState("");
//   const [validationError, setValidationError] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   useEffect(() => {
//     const fetchCreditsData = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         const userStr = localStorage.getItem('user');
//         const user = userStr ? JSON.parse(userStr) : null;
        
//         if (user) {
//           setUserRole(user.role);
          
//           if (['admin', 'Manager'].includes(user.role)) {
//             setCredits(999);
//             setLoadingCredits(false);
//             return;
//           }

//           const res = await axios.get(`${backendUrl}/credits/my-wallet`, {
//             headers: { 'x-auth-token': token }
//           });
//           setCredits(res.data.balance);
//         }
//       } catch (error) {
//         console.error('Failed to fetch credits:', error);
//         setCredits(0);
//       } finally {
//         setLoadingCredits(false);
//       }
//     };

//     fetchCreditsData();
//   }, []);

//   // 🎯 Real-time IMEI validation
//   const handleIMEIChange = (e) => {
//     const value = e.target.value.replace(/[^0-9]/g, "");
//     setNewDeviceIMEI(value);
    
//     if (value.length > 0 && value.length !== 15) {
//       setValidationError(`IMEI must be 15 digits (currently ${value.length})`);
//     } else {
//       setValidationError("");
//     }
//   };

//   // 🎯 Wrap submit with loading state
//   const handleSubmitDevice = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     try {
//       await handleAddDevice(e);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleValidateIMEI = async (e) => {
//     e.preventDefault();
//     if (newDeviceIMEI.length !== 15) {
//       setValidationError("IMEI must be exactly 15 digits");
//       return;
//     }
//     setValidationError("");
//     setIsSubmitting(true);
//     try {
//       await handleIMEIValidation(e);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const isStaff = ['admin', 'Manager'].includes(userRole);
//   const canAddDevice = isStaff || (credits !== null && credits > 0);

//   return (
//     <div className="modal-overlay">
//       <div className="modal-content" style={{ maxWidth: '600px' }}>
        
//         {/* Header */}
//         <div style={{ 
//           padding: '16px 20px', 
//           borderBottom: '1px solid #e5e7eb', 
//           display: 'flex', 
//           justifyContent: 'space-between', 
//           alignItems: 'center',
//           background: '#f9fafb'
//         }}>
//           <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
//             <Car size={22} color="#4f46e5" /> 
//             {isIMEIValid ? "Complete Device Details" : "Validate Device IMEI"}
//           </h3>
//           {!isStaff && !loadingCredits && (
//             <span style={{ 
//               padding: '4px 12px', 
//               borderRadius: '20px', 
//               fontSize: '13px',
//               fontWeight: '600',
//               background: credits > 0 ? '#dcfce7' : '#fee2e2',
//               color: credits > 0 ? '#166534' : '#991b1b'
//             }}>
//               Credits: {credits}
//             </span>
//           )}
//         </div>

//         <div style={{ padding: '20px' }}>
//           {loadingCredits ? (
//             <div style={{ textAlign: 'center', padding: '40px' }}>
//               <Loader2 className="animate-spin" size={32} color="#4f46e5" />
//               <p style={{ marginTop: '10px', color: '#6b7280' }}>Checking wallet...</p>
//             </div>
//           ) : !canAddDevice ? (
//             /* No Credits Alert */
//             <div style={{ 
//               background: '#fef2f2', 
//               border: '1px solid #fecaca', 
//               borderRadius: '8px', 
//               padding: '16px' 
//             }}>
//               <div style={{ display: 'flex', gap: '12px' }}>
//                 <AlertCircle color="#dc2626" size={24} />
//                 <div>
//                   <h4 style={{ margin: '0 0 8px 0', color: '#991b1b' }}>Insufficient Credits</h4>
//                   <p style={{ margin: 0, color: '#b91c1c', fontSize: '14px' }}>
//                     You need at least 1 credit to add a device. Contact admin for recharge.
//                   </p>
//                 </div>
//               </div>
//               <button 
//                 onClick={() => setShowAddDeviceModal(false)}
//                 style={{ 
//                   marginTop: '16px', 
//                   width: '100%', 
//                   padding: '10px', 
//                   background: '#dc2626', 
//                   color: 'white', 
//                   border: 'none', 
//                   borderRadius: '6px',
//                   cursor: 'pointer'
//                 }}
//               >
//                 Close
//               </button>
//             </div>
//           ) : !isIMEIValid ? (
//             /* STEP 1: IMEI Validation */
//             <form onSubmit={handleValidateIMEI}>
//               <div style={{ 
//                 background: '#eff6ff', 
//                 padding: '12px', 
//                 borderRadius: '6px', 
//                 marginBottom: '16px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '8px'
//               }}>
//                 <Info size={18} color="#2563eb" />
//                 <span style={{ fontSize: '14px', color: '#1e40af' }}>
//                   Enter IMEI to auto-fetch device details from assets
//                 </span>
//               </div>

//               <div style={{ marginBottom: '16px' }}>
//                 <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
//                   Device IMEI Number *
//                 </label>
//                 <input 
//                   type="text" 
//                   value={newDeviceIMEI}
//                   onChange={handleIMEIChange}
//                   placeholder="Enter 15 digit IMEI"
//                   maxLength="15"
//                   required
//                   style={{ 
//                     width: '100%', 
//                     padding: '10px 12px', 
//                     border: validationError ? '2px solid #ef4444' : '1px solid #d1d5db',
//                     borderRadius: '6px',
//                     fontSize: '15px'
//                   }}
//                 />
//                 {validationError && (
//                   <p style={{ color: '#ef4444', fontSize: '13px', marginTop: '4px' }}>
//                     {validationError}
//                   </p>
//                 )}
//                 <p style={{ color: '#6b7280', fontSize: '12px', marginTop: '4px' }}>
//                   {newDeviceIMEI.length}/15 digits
//                 </p>
//               </div>

//               <div style={{ display: 'flex', gap: '12px' }}>
//                 <button 
//                   type="submit" 
//                   disabled={isSubmitting || newDeviceIMEI.length !== 15}
//                   style={{ 
//                     flex: 1, 
//                     padding: '12px', 
//                     background: newDeviceIMEI.length === 15 ? '#4f46e5' : '#9ca3af',
//                     color: 'white', 
//                     border: 'none', 
//                     borderRadius: '6px',
//                     cursor: newDeviceIMEI.length === 15 ? 'pointer' : 'not-allowed',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: '8px'
//                   }}
//                 >
//                   {isSubmitting ? <Loader2 className="animate-spin" size={18} /> : <CheckCircle size={18} />}
//                   {isSubmitting ? 'Validating...' : 'Validate IMEI'}
//                 </button>
//                 <button 
//                   type="button" 
//                   onClick={() => { handleCancelValidation(); setShowAddDeviceModal(false); }}
//                   style={{ 
//                     padding: '12px 24px', 
//                     background: 'white', 
//                     border: '1px solid #d1d5db', 
//                     borderRadius: '6px',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           ) : (
//             /* STEP 2: Full Device Form */
//             <form onSubmit={handleSubmitDevice}>
//               {/* Success Banner */}
//               <div style={{ 
//                 background: '#dcfce7', 
//                 padding: '12px', 
//                 borderRadius: '6px', 
//                 marginBottom: '16px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '8px'
//               }}>
//                 <CheckCircle size={18} color="#16a34a" />
//                 <span style={{ fontSize: '14px', color: '#166534' }}>
//                   IMEI Verified! Details auto-filled from asset database.
//                 </span>
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
//                 {/* Vehicle Name */}
//                 <div>
//                   <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
//                     Vehicle Registration *
//                   </label>
//                   <input 
//                     type="text" 
//                     value={newDeviceName} 
//                     onChange={(e) => setNewDeviceName(e.target.value)} 
//                     required 
//                     placeholder="DL-01-AB-1234"
//                     style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '6px' }}
//                   />
//                 </div>

//                 {/* IMEI (Readonly) */}
//                 <div>
//                   <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
//                     IMEI (Verified) ✓
//                   </label>
//                   <input 
//                     type="text" 
//                     value={newDeviceIMEI} 
//                     readOnly 
//                     style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '6px', background: '#f3f4f6' }}
//                   />
//                 </div>

//                 {/* Model (Readonly from Asset) */}
//                 <div>
//                   <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
//                     Device Model (from Asset)
//                   </label>
//                   <input 
//                     type="text" 
//                     value={newDeviceModel} 
//                     readOnly 
//                     style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '6px', background: '#f3f4f6' }}
//                   />
//                 </div>

//                 {/* Device Type */}
//                 <div>
//                   <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
//                     Device Type
//                   </label>
//                   <select 
//                     value={newDeviceType} 
//                     onChange={(e) => setNewDeviceType(e.target.value)} 
//                     style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '6px' }}
//                   >
//                     <option value="hardwire">Hardwire</option>
//                     <option value="portable">Portable</option>
//                     <option value="OBD">OBD</option>
//                     <option value="other">Other</option>
//                   </select>
//                 </div>

//                 {/* Vehicle Type */}
//                 <div>
//                   <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
//                     Vehicle Type
//                   </label>
//                   <select 
//                     value={newDeviceVehicleType} 
//                     onChange={(e) => setNewDeviceVehicleType(e.target.value)}
//                     style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '6px' }}
//                   >
//                     <option value="car">🚗 Car</option>
//                     <option value="truck">🚚 Truck</option>
//                     <option value="bus">🚌 Bus</option>
//                     <option value="van">🚐 Van</option>
//                     <option value="taxi">🚕 Taxi</option>
//                     <option value="jeep">🚙 Jeep</option>
//                     <option value="bike">🏍️ Bike</option>
//                     <option value="tractor">🚜 Tractor</option>
//                   </select>
//                 </div>

//                 {/* SIM Section Header */}
//                 <div style={{ gridColumn: '1 / -1', marginTop: '8px' }}>
//                   <h4 style={{ margin: '0 0 4px 0', fontSize: '14px', color: '#374151' }}>
//                     SIM Card Details (Auto-filled from Asset)
//                   </h4>
//                   <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb' }} />
//                 </div>

//                 {/* MSDN (SIM Number) */}
//            {/* MSDN (SIM Number) */}
// <div>
//   <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
//     MSDN (SIM Number)
//   </label>
//   <input 
//     type="text" 
//     value={newDeviceMSDN || ""} 
//     onChange={(e) => setNewDeviceMSDN(e.target.value.replace(/[^0-9]/g, ""))} 
//     placeholder={newDeviceMSDN ? "" : "Not in asset - enter manually"}
//     maxLength="13"
//     style={{ 
//       width: '100%', 
//       padding: '10px', 
//       border: '1px solid #d1d5db', 
//       borderRadius: '6px',
//       background: newDeviceMSDN ? '#f0fdf4' : '#fff7ed'
//     }}
//   />
//   {!newDeviceMSDN && (
//     <p style={{ color: '#ea580c', fontSize: '11px', marginTop: '2px' }}>
//       ⚠️ SIM not found in asset
//     </p>
//   )}
// </div>

// {/* IMSI */}
// <div>
//   <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
//     IMSI Number
//   </label>
//   <input 
//     type="text" 
//     value={newDeviceIMSI || ""} 
//     onChange={(e) => setNewDeviceIMSI(e.target.value.replace(/[^0-9]/g, ""))} 
//     placeholder={newDeviceIMSI ? "" : "Not in asset - enter manually"}
//     maxLength="15"
//     style={{ 
//       width: '100%', 
//       padding: '10px', 
//       border: '1px solid #d1d5db', 
//       borderRadius: '6px',
//       background: newDeviceIMSI ? '#f0fdf4' : '#fff7ed'
//     }}
//   />
//   {!newDeviceIMSI && (
//     <p style={{ color: '#ea580c', fontSize: '11px', marginTop: '2px' }}>
//       ⚠️ IMSI not found in asset
//     </p>
//   )}
// </div>

//                 {/* IMSI */}
//                 <div>
//                   <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
//                     IMSI Number
//                   </label>
//                   <input 
//                     type="text" 
//                     value={newDeviceIMSI} 
//                     onChange={(e) => setNewDeviceIMSI(e.target.value.replace(/[^0-9]/g, ""))} 
//                     placeholder="Auto-filled or enter manually"
//                     maxLength="15"
//                     style={{ 
//                       width: '100%', 
//                       padding: '10px', 
//                       border: '1px solid #d1d5db', 
//                       borderRadius: '6px',
//                       background: newDeviceIMSI ? '#f0fdf4' : 'white'
//                     }}
//                   />
//                 </div>
//               </div>

//               {/* Credit Info */}
//               {!isStaff && (
//                 <div style={{ 
//                   background: '#eef2ff', 
//                   padding: '12px', 
//                   borderRadius: '6px', 
//                   marginTop: '16px',
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center'
//                 }}>
//                   <span style={{ fontSize: '14px', color: '#4338ca' }}>
//                     This will deduct 1 credit from your wallet
//                   </span>
//                   <span style={{ fontWeight: '600', color: '#3730a3' }}>
//                     {credits} → {credits - 1}
//                   </span>
//                 </div>
//               )}

//               {/* Buttons */}
//               <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
//                 <button 
//                   type="submit" 
//                   disabled={isSubmitting}
//                   style={{ 
//                     flex: 1, 
//                     padding: '12px', 
//                     background: '#4f46e5',
//                     color: 'white', 
//                     border: 'none', 
//                     borderRadius: '6px',
//                     cursor: 'pointer',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: '8px',
//                     fontWeight: '600'
//                   }}
//                 >
//                   {isSubmitting ? <Loader2 className="animate-spin" size={18} /> : <CheckCircle size={18} />}
//                   {isSubmitting ? 'Adding Device...' : 'Add Device'}
//                 </button>
//                 <button 
//                   type="button" 
//                   onClick={() => { handleCancelValidation(); setShowAddDeviceModal(false); }}
//                   style={{ 
//                     padding: '12px 24px', 
//                     background: 'white', 
//                     border: '1px solid #d1d5db', 
//                     borderRadius: '6px',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AddDeviceModal;
import React, { useState, useEffect } from 'react';
import { Car, AlertCircle, CheckCircle, Loader2, Info } from 'lucide-react';
import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://app.krush.in/api';

function AddDeviceModal({
  isIMEIValid,
  handleIMEIValidation,
  handleCancelValidation,
  handleAddDevice,
  newDeviceModel,
  setNewDeviceModel,
  newDeviceName,
  setNewDeviceName,
  newDeviceIMEI,
  setNewDeviceIMEI,
  newDeviceMSDN,
  setNewDeviceMSDN,
  newDeviceIMSI,
  setNewDeviceIMSI,
  newDeviceType,
  setNewDeviceType,
  setShowAddDeviceModal,
  newDeviceVehicleType,
  setNewDeviceVehicleType,
}) {
  const [credits, setCredits] = useState(null);
  const [loadingCredits, setLoadingCredits] = useState(true);
  const [userRole, setUserRole] = useState("");
  const [validationError, setValidationError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchCreditsData = async () => {
      try {
        const token = localStorage.getItem('token');
        const userStr = localStorage.getItem('user');
        const user = userStr ? JSON.parse(userStr) : null;
        
        if (user) {
          const normalizedRole = String(user.role || "").trim().toLowerCase();
          setUserRole(normalizedRole);
          
          if (['admin', 'manager'].includes(normalizedRole)) {
            setCredits(999);
            setLoadingCredits(false);
            return;
          }

          const res = await axios.get(`${backendUrl}/credits/my-wallet`, {
            headers: { 'x-auth-token': token }
          });
          setCredits(res.data.balance);
        }
      } catch (error) {
        console.error('Failed to fetch credits:', error);
        setCredits(0);
      } finally {
        setLoadingCredits(false);
      }
    };

    fetchCreditsData();
  }, []);

  const handleIMEIChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setNewDeviceIMEI(value);
    
    if (value.length > 0 && value.length !== 15) {
      setValidationError(`IMEI must be 15 digits (currently ${value.length})`);
    } else {
      setValidationError("");
    }
  };

  const handleSubmitDevice = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await handleAddDevice(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleValidateIMEI = async (e) => {
    e.preventDefault();
    if (newDeviceIMEI.length !== 15) {
      setValidationError("IMEI must be exactly 15 digits");
      return;
    }
    setValidationError("");
    setIsSubmitting(true);
    try {
      await handleIMEIValidation(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isStaff = ['admin', 'manager'].includes(userRole);
  const canAddDevice = isStaff || (credits !== null && credits > 0);

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '600px' }}>
        
        {/* Header */}
        <div style={{ 
          padding: '16px 20px', 
          borderBottom: '1px solid #e5e7eb', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          background: '#f9fafb'
        }}>
          <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Car size={22} color="#4f46e5" /> 
            {isIMEIValid ? "Complete Device Details" : "Validate Device IMEI"}
          </h3>
          {!isStaff && !loadingCredits && (
            <span style={{ 
              padding: '4px 12px', 
              borderRadius: '20px', 
              fontSize: '13px',
              fontWeight: '600',
              background: credits > 0 ? '#dcfce7' : '#fee2e2',
              color: credits > 0 ? '#166534' : '#991b1b'
            }}>
              Credits: {credits}
            </span>
          )}
        </div>

        <div style={{ padding: '20px' }}>
          {loadingCredits ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <Loader2 className="animate-spin" size={32} color="#4f46e5" />
              <p style={{ marginTop: '10px', color: '#6b7280' }}>Checking wallet...</p>
            </div>
          ) : !canAddDevice ? (
            <div style={{ 
              background: '#fef2f2', 
              border: '1px solid #fecaca', 
              borderRadius: '8px', 
              padding: '16px' 
            }}>
              <div style={{ display: 'flex', gap: '12px' }}>
                <AlertCircle color="#dc2626" size={24} />
                <div>
                  <h4 style={{ margin: '0 0 8px 0', color: '#991b1b' }}>Insufficient Credits</h4>
                  <p style={{ margin: 0, color: '#b91c1c', fontSize: '14px' }}>
                    You need at least 1 credit to add a device. Contact admin for recharge.
                  </p>
                </div>
              </div>
              <button 
                onClick={() => setShowAddDeviceModal(false)}
                style={{ 
                  marginTop: '16px', 
                  width: '100%', 
                  padding: '10px', 
                  background: '#dc2626', 
                  color: 'white', 
                  border: 'none', 
                  borderRadius: '6px',
                  cursor: 'pointer'
                }}
              >
                Close
              </button>
            </div>
          ) : !isIMEIValid ? (
            /* STEP 1: IMEI Validation */
            <form onSubmit={handleValidateIMEI}>
              <div style={{ 
                background: '#eff6ff', 
                padding: '12px', 
                borderRadius: '6px', 
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <Info size={18} color="#2563eb" />
                <span style={{ fontSize: '14px', color: '#1e40af' }}>
                  Enter IMEI to auto-fetch device details from assets
                </span>
              </div>

              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                  Device IMEI Number *
                </label>
                <input 
                  type="text" 
                  value={newDeviceIMEI}
                  onChange={handleIMEIChange}
                  placeholder="Enter 15 digit IMEI"
                  maxLength="15"
                  required
                  style={{ 
                    width: '100%', 
                    padding: '10px 12px', 
                    border: validationError ? '2px solid #ef4444' : '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '15px'
                  }}
                />
                {validationError && (
                  <p style={{ color: '#ef4444', fontSize: '13px', marginTop: '4px' }}>
                    {validationError}
                  </p>
                )}
                <p style={{ color: '#6b7280', fontSize: '12px', marginTop: '4px' }}>
                  {newDeviceIMEI.length}/15 digits
                </p>
              </div>

              <div style={{ display: 'flex', gap: '12px' }}>
                <button 
                  type="submit" 
                  disabled={isSubmitting || newDeviceIMEI.length !== 15}
                  style={{ 
                    flex: 1, 
                    padding: '12px', 
                    background: newDeviceIMEI.length === 15 ? '#4f46e5' : '#9ca3af',
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '6px',
                    cursor: newDeviceIMEI.length === 15 ? 'pointer' : 'not-allowed',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  {isSubmitting ? <Loader2 className="animate-spin" size={18} /> : <CheckCircle size={18} />}
                  {isSubmitting ? 'Validating...' : 'Validate IMEI'}
                </button>
                <button 
                  type="button" 
                  onClick={() => { handleCancelValidation(); setShowAddDeviceModal(false); }}
                  style={{ 
                    padding: '12px 24px', 
                    background: 'white', 
                    border: '1px solid #d1d5db', 
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          ) : (
            /* STEP 2: Full Device Form */
            <form onSubmit={handleSubmitDevice}>
              {/* Success Banner */}
              <div style={{ 
                background: '#dcfce7', 
                padding: '12px', 
                borderRadius: '6px', 
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <CheckCircle size={18} color="#16a34a" />
                <span style={{ fontSize: '14px', color: '#166534' }}>
                  IMEI Verified! Details auto-filled from asset database.
                </span>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                {/* Vehicle Name */}
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                    Vehicle Registration *
                  </label>
                  <input 
                    type="text" 
                    value={newDeviceName} 
                    onChange={(e) => setNewDeviceName(e.target.value)} 
                    required 
                    placeholder="DL-01-AB-1234"
                    style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '6px' }}
                  />
                </div>

                {/* IMEI (Readonly) */}
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                    IMEI (Verified) ✓
                  </label>
                  <input 
                    type="text" 
                    value={newDeviceIMEI} 
                    readOnly 
                    style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '6px', background: '#f3f4f6' }}
                  />
                </div>

                {/* Model (Readonly from Asset) */}
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                    Device Model (from Asset)
                  </label>
                  <input 
                    type="text" 
                    value={newDeviceModel} 
                    readOnly 
                    style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '6px', background: '#f3f4f6' }}
                  />
                </div>

                {/* Device Type */}
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                    Device Type
                  </label>
                  <select 
                    value={newDeviceType} 
                    onChange={(e) => setNewDeviceType(e.target.value)} 
                    style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '6px' }}
                  >
                    <option value="hardwire">Hardwire</option>
                    <option value="portable">Portable</option>
                    <option value="OBD">OBD</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                {/* Vehicle Type */}
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                    Vehicle Type
                  </label>
                  <select 
                    value={newDeviceVehicleType} 
                    onChange={(e) => setNewDeviceVehicleType(e.target.value)}
                    style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '6px' }}
                  >
                    <option value="car">🚗 Car</option>
                    <option value="truck">🚚 Truck</option>
                    <option value="bus">🚌 Bus</option>
                    <option value="van">🚐 Van</option>
                    <option value="taxi">🚕 Taxi</option>
                    <option value="jeep">🚙 Jeep</option>
                    <option value="bike">🏍️ Bike</option>
                    <option value="tractor">🚜 Tractor</option>
                    <option value="jcb">🏗️ JCB</option>
                    <option value="plane">✈️ Plane</option>
                  </select>
                </div>

                {/* SIM Section Header */}
                <div style={{ gridColumn: '1 / -1', marginTop: '8px' }}>
                  <h4 style={{ margin: '0 0 4px 0', fontSize: '14px', color: '#374151', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    📱 SIM Card Details 
                    {(newDeviceMSDN || newDeviceIMSI) && (
                      <span style={{ fontSize: '11px', color: '#16a34a', fontWeight: 'normal' }}>
                        (Auto-filled from Asset)
                      </span>
                    )}
                  </h4>
                  <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb' }} />
                </div>

                {/* MSDN (SIM Number) */}
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                    MSDN (SIM Number)
                  </label>
                  <input 
                    type="text" 
                    value={newDeviceMSDN || ""} 
                    onChange={(e) => setNewDeviceMSDN(e.target.value.replace(/[^0-9]/g, ""))} 
                    placeholder="Enter SIM number"
                    maxLength="13"
                    style={{ 
                      width: '100%', 
                      padding: '10px', 
                      border: '1px solid #d1d5db', 
                      borderRadius: '6px',
                      background: newDeviceMSDN ? '#f0fdf4' : 'white'
                    }}
                  />
                  {newDeviceMSDN ? (
                    <p style={{ color: '#16a34a', fontSize: '11px', marginTop: '2px' }}>
                      ✓ From asset database
                    </p>
                  ) : (
                    <p style={{ color: '#6b7280', fontSize: '11px', marginTop: '2px' }}>
                      Optional - Enter manually if not in asset
                    </p>
                  )}
                </div>

                {/* IMSI */}
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '14px' }}>
                    IMSI Number
                  </label>
                  <input 
                    type="text" 
                    value={newDeviceIMSI || ""} 
                    onChange={(e) => setNewDeviceIMSI(e.target.value.replace(/[^0-9]/g, ""))} 
                    placeholder="Enter IMSI"
                    maxLength="15"
                    style={{ 
                      width: '100%', 
                      padding: '10px', 
                      border: '1px solid #d1d5db', 
                      borderRadius: '6px',
                      background: newDeviceIMSI ? '#f0fdf4' : 'white'
                    }}
                  />
                  {newDeviceIMSI ? (
                    <p style={{ color: '#16a34a', fontSize: '11px', marginTop: '2px' }}>
                      ✓ From asset database
                    </p>
                  ) : (
                    <p style={{ color: '#6b7280', fontSize: '11px', marginTop: '2px' }}>
                      Optional - Enter manually if not in asset
                    </p>
                  )}
                </div>
              </div>

              {/* Credit Info */}
              {!isStaff && (
                <div style={{ 
                  background: '#eef2ff', 
                  padding: '12px', 
                  borderRadius: '6px', 
                  marginTop: '16px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <span style={{ fontSize: '14px', color: '#4338ca' }}>
                    This will deduct 1 credit from your wallet
                  </span>
                  <span style={{ fontWeight: '600', color: '#3730a3' }}>
                    {credits} → {credits - 1}
                  </span>
                </div>
              )}

              {/* Buttons */}
              <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                <button 
                  type="submit" 
                  disabled={isSubmitting}
                  style={{ 
                    flex: 1, 
                    padding: '12px', 
                    background: isSubmitting ? '#9ca3af' : '#4f46e5',
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '6px',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    fontWeight: '600'
                  }}
                >
                  {isSubmitting ? <Loader2 className="animate-spin" size={18} /> : <CheckCircle size={18} />}
                  {isSubmitting ? 'Adding Device...' : 'Add Device'}
                </button>
                <button 
                  type="button" 
                  onClick={() => { handleCancelValidation(); setShowAddDeviceModal(false); }}
                  disabled={isSubmitting}
                  style={{ 
                    padding: '12px 24px', 
                    background: 'white', 
                    border: '1px solid #d1d5db', 
                    borderRadius: '6px',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer'
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddDeviceModal;
